(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[870],{

/***/ 2917:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-team",
      function () {
        return __webpack_require__(5245);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Team; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/common/index.ts + 9 modules
var common = __webpack_require__(108);
// EXTERNAL MODULE: ./src/ui/index.ts + 16 modules
var ui = __webpack_require__(4522);
// EXTERNAL MODULE: ./src/ui/cursive-basic.tsx
var cursive_basic = __webpack_require__(4693);
;// CONCATENATED MODULE: ./src/components/ourTeam/join.tsx


var JoinTeam = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "m-auto grid w-[90%] grid-cols-1 gap-8 text-center text-base text-colorFifteen lg:w-[60%]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* TextBold */.DU, {
                className: "text-center text-lg",
                children: "Love looking after the health of dogs? Join the Tucker Tub Team by becoming a Distributor."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ButtonWithArrow */.Ub, {
                href: "/contact",
                center: true,
                buttonVariant: "primary",
                className: "m-auto w-[100%] lg:w-[240px]",
                children: "Join the Team"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(9855);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(3342);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./src/components/ourTeam/team-card.tsx

/* eslint-disable @next/next/no-img-element */ 



function TeamCard(props) {
    var ref;
    var data = props.data;
    var _sourceUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full w-full max-w-[440px] justify-self-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-[-80px] ml-[30px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (_sourceUrl = (ref = data.node.featuredImage) === null || ref === void 0 ? void 0 : ref.node.sourceUrl) !== null && _sourceUrl !== void 0 ? _sourceUrl : "/assets/images/product-image-placeholder.svg",
                    alt: "Team Member",
                    width: 219,
                    height: 188,
                    className: "h-[160px] w-[160px] rounded-full object-cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full rounded-lg bg-colorFifteen/10 px-8 pb-8 pt-24 text-colorFifteen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                    children: function(param) {
                        var open = param.open;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-lg font-bold",
                                    children: data.node.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                    className: "flex w-full justify-between rounded-lg text-left text-sm font-medium",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                            children: data.node.Team.memberRegion
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                            className: "".concat(open ? "rotate-180" : "", " h-8 w-8 text-colorFifteen")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Panel */.p.Panel, {
                                    className: "py-2 text-base text-colorFifteen",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "prose text-inherit",
                                            dangerouslySetInnerHTML: {
                                                __html: data.node.Team.bio
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-5 pt-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: data.node.Team.memberFacebook,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/social/facebook.svg",
                                                        alt: "Facebook",
                                                        height: 24,
                                                        width: 24
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: data.node.Team.memberPhone
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/ourTeam/index.tsx





var OurTeamContent = function(props) {
    var teamData = props.teamData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full w-full bg-colorFourteen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CurveBanner */.kq, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Header */.h4, {
                    className: "m-auto w-[80%] text-colorFourteen",
                    children: "Our Team"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Wrapper */.im, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-[200px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                                className: "text-colorFifteen",
                                children: "Tucker Tub Distributors"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cursive_basic/* CursiveBasic */.x, {
                                className: "text-blockHeader text-colorSixteen",
                                children: "Local dog experts delivering to your door"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-5 font-haboro-soft text-colorFifteen",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                    children: "Our Tucker Tub team of distributors services regional Victoria, where it all started from. The passionate crew has a weekly delivery schedule, offering free delivery direct to your door for all orders. They are a helpful bunch and enjoy seeing all of their loyal customers, and their favourite doggos! Your local distributor is happy to help with feeding advice and recommendations to keep your pup healthy."
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "grid grid-cols-1 gap-y-28 gap-x-8 px-8 py-20 md:grid-cols-2 xl:grid-cols-3",
                children: [
                    teamData.map(function(person) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamCard, {
                            data: person
                        }, person.node.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinTeam, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/our-team/index.tsx




var __N_SSG = true;
function Team(param) {
    var data = param.data;
    console.log("Team Data", data);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Our Team | Tucker Tub",
                description: "Our Team Description",
                openGraph: {
                    title: "Our Team | Tucker Tub",
                    description: "Our Team Description",
                    url: "https://preview.tuckertub.com.au",
                    type: "website",
                    locale: "en_AU",
                    site_name: "Tucker Tub"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Layout */.Ar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurTeamContent, {
                    teamData: data
                })
            })
        ]
    });
};


/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CursiveBasic; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CursiveBasic = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "m-auto font-madelyn text-sliderTitle text-colorSixteen lg:text-blockHeader ".concat(className),
        children: children
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4507,236,5812,8969,9774,2888,179], function() { return __webpack_exec__(2917); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);